// api/copilotApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UATConstants } from 'src/Common/Models/UATConstants';

export interface RecommendationFields {
  Title: string;
  AccountName?: string;
  OfferingName?: string;
  ServiceName?: string;
  Description?: string;
  BusinessScenario?: string;
  CustomerImpact?: string;
  WorkaroundDetails?: string;
  AzureRegions?: string;
  IssueType?: string;
}

export interface RecommendationRequest {
  AppName: string;
  Fields: RecommendationFields;
  FilterCondition: string;
  Top: number;
}

export interface RecommendationResponse {
  items: Array<string>;
}

export const copilotApi = createApi({
  reducerPath: 'copilotApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${UATConstants.CommonServicesWebApiUrl}/api/v1/GPTTurnKey`,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem(UATConstants.jwtTokenForApi);
      const coreAPIToken = sessionStorage.getItem(UATConstants.jwtTokenForCoreApi);
      const graphToken = sessionStorage.getItem(UATConstants.jwtTokenForGraph);

      if (token && graphToken && coreAPIToken) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Coreapitoken', coreAPIToken);
        headers.set('Graphtoken', graphToken);
      }
      return headers;
    },
  }),
  tagTypes: ['Recommendation'],
  endpoints: (builder) => ({
    getRecommendations: builder.mutation<RecommendationResponse, RecommendationRequest>({
      query: (body) => ({
        url: '/Recommendations',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Recommendation'],
    }),
  }),
});

export const { useGetRecommendationsMutation } = copilotApi;
